<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-bell"></i> {{ _('Notification schedule') }}</h3>
        </div>
      </div>
      <div class="list-filter-row form-group">
        <div class="list-filter-col">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="list-filter-col" v-if="!showExactRange">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Date range') }}</div>
              <select class="form-control" id="notificationRangeFilter" v-model="dateRange">
								<option value="overview" selected>{{ _('Overview') }}</option>
								<option value="upcoming">{{ _('All upcoming') }}</option>
								<option value="sent">{{ _('All sent') }}</option>
								<option value="all">{{ _('All notifications') }}</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="showExactRange">
          <div class="rangeFields pull-right">
            <div class="form-inline">
              <div class="form-group">
                <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
              </div>
              <label for="endDate"> - </label>
              <div class="form-group">
                <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
              </div>
            </div>
          </div>
        </div>
        <div class="filtercol">
    			<button id="selectRange" type="button" class="btn btn-default" v-on:click="selectRange" v-if="!showExactRange"><div class=""></div>{{ _('Select exact date range') }}</button>
    			<button id="unselectRange" type="button" class="btn btn-default" v-on:click="unselectRange" v-else><div class=""></div>{{ _('Cancel') }}</button>
        </div>
      </div>
      <Datatable :url="notificationsUrl" :search="search" :date-range-filter="dateRangeFilter" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, ANotificationDetails } from '#components'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      notifications: [],
      search: '',
      dateStart: false,
      dateEnd: false,
      dateRange: 'upcoming',
      showExactRange: false,
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 110,
          responsive: 0
        },
        {
          title: _('Send time'),
          field: 'ts',
          widthGrow: 4,
          formatter: $this.dateAndTimeFormatter(),
          responsive: 0
        },
        {
          title: _('Notification'),
          field: 'notification',
          widthGrow: 5
        },
        {
          title: _('Recipient'),
          field: 'email',
          widthGrow: 4,
          formatter: $this.notificationRecipientFormatter()
        },
        {
          title: _('Customer'),
          field: 'client',
          widthGrow: 4
        },
        {
          title: _('Status'),
          field: 'status',
          widthGrow: 4,
          formatter: $this.notificationStatusFormatter(),
          cellClick: $this.resetStatus
        },
        ],
        initialSort: [{
          column: 'ts',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    notificationsUrl () {
      return this.baseDomain + this.shopId + '/notificationschedule.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    dateRangeFilter: {
      get () {
        if (this.dateStart && this.dateEnd) {
          return DateTime.fromJSDate(this.dateStart, { zone: this.timezone }).toFormat('d.M.yyyy') + '-' + DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        return this.dateRange
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          this.showExactRange = false
          this.dateStart = false
          this.dateEnd = false
          this.dateRange = newValue
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    }
  },
  methods: {
    editRow (row) {
      const id = row.getCell('id').getValue()
      const notification = row.getData()
      this.showModal('notificationdetails', ANotificationDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              notificationId: id,
              notification: notification,
              modal: true
            }
          }
        },
        events: {},
        handlers: {
          closed: (e) => {
            this.reload()
          }
        },
        width: 1000
      })
    },
    reload () {
      this.$refs.datatable.reload()
    },
    selectRange () {
      this.showExactRange = true
    },
    unselectRange () {
      this.showExactRange = this.dateStart = this.dateEnd = false
    },
    inputDateStart (newValue) {
      this.dateStart = newValue
    },
    inputDateEnd (newValue) {
      this.dateEnd = newValue
    },
    async resetStatus (e, cell) {
      const id = cell.getRow().getCell('id').getValue()
      const status = cell.getRow().getCell('status').getValue()
      if (id && parseInt(status)) {
        let response
        const data = {
          status: 0,
          id: id
        }
        try {
          response = await axios.put(this.baseDomain + this.shopId + '/notificationschedule/' + id.replace(/-/, ':') + '.json?apikey=' + this.apiKey, data)
        } catch(e) {
          return
        }
        this.reload()
      }
    }
  },
  components: {
    Datatable
  }
}
</script>